import { render, staticRenderFns } from "./ProjectsScheduler.vue?vue&type=template&id=35cf93a9"
import script from "./ProjectsScheduler.vue?vue&type=script&lang=ts"
export * from "./ProjectsScheduler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cf93a9')) {
      api.createRecord('35cf93a9', component.options)
    } else {
      api.reload('35cf93a9', component.options)
    }
    module.hot.accept("./ProjectsScheduler.vue?vue&type=template&id=35cf93a9", function () {
      api.rerender('35cf93a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/schedulers/ProjectsScheduler.vue"
export default component.exports